<template>

  <div>
    <DataimexExportModal
      @close="close"
      :promise="exportPromise" />
  </div>

</template>

<script>
import DataimexExportModal from '@/components/Dataimex/DataimexExportModal'

export default {
  name: 'Export',
  props: {
    filters: {
      type: Array
    },
    select: {
      type: Array
    },
    module: {
      type: String
    },
    sort: {
      type: String
    }
  },
  components: {
    DataimexExportModal
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    exportPromise (fileType) {
      return this.axios.post('/accounts/' + this.$store.getters.getAccount._id + '/reporting/export', {
        filters: this.filters,
        select: this.select,
        module: this.module,
        sort: this.sort,
        file_type: fileType
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ReportChart/Export.vue